import FeatureToggleContextProvider, { useFeatureToggleContext } from './FeatureToggleContext';

export { useFeatureToggleContext };
export default FeatureToggleContextProvider;
